export default __webpack_public_path__ + "static/media/art-slt-3.9aa88526.png";